import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from 'gatsby';
import { Button, Group, Container } from '@mantine/core';
import { Footer } from '../components/Footer/Footer';
import { Features } from '../home-page/Features/Features';
import { PackagesTable } from '../home-page/PackagesTable/PackagesTable';
import Head from '../components/Head/Head.tsx';
export const _frontmatter = {
  "title": "Getting started",
  "slug": "/"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const GatsbyLink = makeShortcode("GatsbyLink");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Head title="Mantine" disableTitleTemplate mdxType="Head" />
    <br />
    <br />
    <Container size="sm" mdxType="Container">
      <h1 {...{
        "id": "mantine"
      }}>{`Mantine`}</h1>
      <p>{`Mantine is a MIT licensed open source react components and hooks library
with focus on usability, accessibility and developer experience.`}</p>
      <Group mdxType="Group">
  <Button component={Link} to="/core/getting-started/" mdxType="Button">
    Browse components
  </Button>
  <Button component={Link} to="/hooks/getting-started/" variant="outline" color="gray" mdxType="Button">
    Browse hooks
  </Button>
      </Group>
      <h2 {...{
        "id": "features"
      }}>{`Features`}</h2>
      <Features mdxType="Features" />
      <h2 {...{
        "id": "mantine-packages"
      }}>{`Mantine packages`}</h2>
      <PackagesTable mdxType="PackagesTable" />
      <h2 {...{
        "id": "getting-started"
      }}>{`Getting started`}</h2>
      <p>{`Mantine works out of the box with `}<a parentName="p" {...{
          "href": "https://create-react-app.dev/"
        }}>{`create-react-app`}</a>{` (including `}<a parentName="p" {...{
          "href": "https://create-react-app.dev/docs/adding-typescript/"
        }}>{`TypeScript version`}</a>{`),
`}<a parentName="p" {...{
          "href": "https://github.com/preactjs/preact-cli"
        }}>{`Preact cli`}</a>{` (with compat), `}<a parentName="p" {...{
          "href": "https://nextjs.org/"
        }}>{`Next.js`}</a>{`, `}<a parentName="p" {...{
          "href": "https://www.gatsbyjs.com/"
        }}>{`Gatsby`}</a>{` and any other environment.`}</p>
      <p>{`Install mantine dependencies with yarn:`}</p>
      <pre><code parentName="pre" {...{
          "className": "language-sh"
        }}>{`yarn add react-jss @mantine/hooks @mantine/core
`}</code></pre>
      <p>{`or npm`}</p>
      <pre><code parentName="pre" {...{
          "className": "language-sh"
        }}>{`npm install react-jss @mantine/hooks @mantine/core
`}</code></pre>
      <p>{`And you are ready:`}</p>
      <pre><code parentName="pre" {...{
          "className": "language-tsx"
        }}>{`import React from 'react';
import { Button } from '@mantine/core';

function App() {
  return <Button>My mantine button</Button>;
}
`}</code></pre>
      <p>{`To enable server side rendering in your application see `}<GatsbyLink to="/guides/ssr/" mdxType="GatsbyLink">{`ssr guide`}</GatsbyLink>{`,
it includes tutorials for Gatsby, Next.js and your own server.`}</p>
      <h2 {...{
        "id": "versioning"
      }}>{`Versioning`}</h2>
      <p>{`All mantine packages are released at the same time with exact same version.
After installation you can fix @mantine/scoped packages version in your package.json
to prevent versions mismatch in future:`}</p>
      <pre><code parentName="pre" {...{
          "className": "language-json"
        }}>{`{
  // Fix version by using "1.0.1", not default "^1.0.1"
  "dependencies": {
    "@mantine/core": "1.0.1",
    "@mantine/hooks": "1.0.1"
  }
}
`}</code></pre>
      <Footer mdxType="Footer" />
    </Container>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      